import { AddOn } from './AddOn';

export class AccessControl extends AddOn {
  public get shortDescription(): string {
    return 'Advanced access control includes whitelisting/blacklisting by email and/or domain, requiring work emails, and blocking the use of temporary emails.';
  }

  public get description(): string {
    return 'Limit who (and how many) can access your webinars, like only those who are using a work email address or an email on a specified domain.';
  }

  public get ctaText(): string | null {
    return `Enable advanced access control`;
  }

  public image(): string | null {
    return require('$/images/access-control.png').default;
  }
}
